export default __webpack_public_path__ + "static/media/Fexocon-180-eng.6ecefcd0.jpg";